function identifiable(identifier) {
    return function () { return ({
        onCreate: function () { return ({
            identifier: function (_) { return identifier; }
        }); }
    }); };
}

export { identifiable };
//# sourceMappingURL=index.es.js.map
